
import React, { FC, memo } from "../../../../lib/teact/teact";
import { tienFormat } from "../../utils/NumberUtils";

type OwnProps = {
    data: any;
}
const RenderBaoCaoLaiLo: FC<OwnProps> = ({
    data
}) => {
    let totalLaiLo = 0
    let totalMb = 0
    let totalMt = 0
    let totalMn = 0
    return (
        <div className="balance-container">
            <table className="balance-table">
                <tr className="balance-header">
                    <td className="balance-name">Tên khách</td>
                    <td>M.Bắc</td>
                    <td>M.Trung</td>
                    <td>M.Nam</td>
                    <td>Lãi/Lỗ</td>
                </tr>
                {

                    Object.keys(data)?.map((contactId) => {
                        const item: any = data[contactId]
                        const cls = item.laiLo >= 0 ? " lai" : " lo"
                        totalLaiLo += item.laiLo;
                        totalMb += item.mienBac;
                        totalMt += item.mienTrung;
                        totalMn += item.mienNam;
                        return (<tr key={"lailo-" + contactId}>
                            <td className="balance-name">{item.name}</td>
                            <td className={"balance-money " + (item.mienBac >= 0 ? " lai" : " lo")}>
                                {tienFormat(item.mienBac, 1)}</td>
                            <td className={"balance-money" + (item.mienTrung >= 0 ? " lai" : " lo")}>
                                {tienFormat(item.mienTrung, 1)}</td>
                            <td className={"balance-money" + (item.mienNam >= 0 ? " lai" : " lo")}>
                                {tienFormat(item.mienNam, 1)}</td>
                            <td className={"balance-money" + cls}>
                                {tienFormat(item.laiLo, 1)}</td>
                        </tr>)
                    })
                }
                <tr>
                    <td className="balance-name">{"Cộng"}</td>
                    <td className={"balance-money-total " + (totalMb >= 0 ? " lai" : "lo")}>
                        {tienFormat(totalMb, 1)}
                    </td>
                    <td className={"balance-money-total " + (totalMt >= 0 ? " lai" : "lo")}>
                        {tienFormat(totalMt, 1)}
                    </td>
                    <td className={"balance-money-total " + (totalMn >= 0 ? " lai" : "lo")}>
                        {tienFormat(totalMn, 1)}
                    </td>
                    <td className={"balance-money-total " + (totalLaiLo >= 0 ? " lai" : "lo")}>
                        {tienFormat(totalLaiLo, 1)}
                    </td>
                </tr>
            </table>
        </div>
    )
}

export default memo(RenderBaoCaoLaiLo)